// extracted by mini-css-extract-plugin
export default {"control":"Control_control__d8qcr","button":"Control_button__TmRT6"};